<template>
  <v-data-table
    v-model="itensSelecionados"
    :headers="headers"
    :items="items"
    height="calc(100vh - 258px)"
    class="table-full-screen"
    item-key="filial"
    fixed-header
    show-select
    show-expand
    single-expand
    :items-per-page="-1"
  >
    <template v-slot:top>
      <topo-tabela
        class="ml-n1"
        :itemSelecionado="itemSelecionado"
        @atualizar-tabela-filiais-mapeadas="getListaFiliaisMapeadas"
        @fecha:dialog="itemSelecionado = $event"
        @update:dataTable="getListaFiliaisMapeadas"
      >
        <v-badge bordered color="white" overlap v-show="itensSelecionados.length">
          <template v-slot:badge>
            <div style="color: #000000">{{itensSelecionados.length}}</div>
          </template>

          <v-btn
            small
            class="ml-1"
            color="error"
            @click="excluirMapeamentoFilial(Helpers.arrayColumn(itensSelecionados, 'filial'))"
          >
            <v-icon left>mdi-delete</v-icon>
            remover
          </v-btn>
        </v-badge>
      </topo-tabela>
    </template>

    <template v-slot:item.grupos_familia="{item: row}">
      <coluna-com-categorias-mapeadas :categorias="row.categorias.filter(item => !item.sub_categoria)" />
    </template>

    <template v-slot:item.acoes="{item}">
      <div class="d-flex">
        <v-btn icon @click="editarItem(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-btn icon @click="excluirMapeamentoFilial([item.filial])">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </template>

    <template v-slot:item.data-table-expand="{expand, isExpanded}">
      <v-btn icon @click="expand(!isExpanded)">
        <v-icon v-if="isExpanded">mdi-chevron-up</v-icon>
        <v-icon v-else>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <template v-slot:item.familiais_gerais="{item: row}">
      <coluna-com-categorias-mapeadas :categorias="row.familiais_gerais" />
    </template>

    <template v-slot:item.categorias="{item: row}">
      <coluna-com-categorias-mapeadas :categorias="row.categorias.filter(item => item.sub_categoria)" />
    </template>

    <template v-slot:expanded-item="{item}">
      <linha-data-table-expandida :qtde-td="headers.length + 1" :linha="item" />
    </template>
  </v-data-table>
</template>

<script>
import TopoTabela from "./TopoTabelaFiliaisMapeadas"
import FilialAPI from "../../../api/filial"
import LinhaDataTableExpandida from "./LinhaDataTableExpandida";
import ColunaComCategoriasMapeadas from "./ColunaComCategoriasMapeadas";

export default {
  name: "TabelaFiliaisMapeadasPorFamilia",
  components: {ColunaComCategoriasMapeadas, LinhaDataTableExpandida, TopoTabela},
  data: () => ({
    headers: [
      { text: '', value: 'data-table-select' },
      { text: 'Descrição do Grupo', value: 'descricao_grupo' },
      { text: 'Filial', value: 'filial' },
      { text: 'Família', value: 'familiais_gerais' },
      { text: 'Grupos da Família', value: 'grupos_familia' },
      { text: 'Categorias', value: 'categorias' },
      { text: '', value: 'data-table-expand', width: '5px' },
      { text: 'Ações', value: 'acoes', width: '5px' },
    ],
    items: [],
    itemSelecionado: {},
    itensSelecionados: []
  }),
  mounted() {
    this.getListaFiliaisMapeadas()
  },
  methods: {
    getListaFiliaisMapeadas () {
      const headers = this.Helpers.iniciarRequisicao()

      this.$store.dispatch("loading/addRequisicao",
        FilialAPI.getListaFiliaisMapeadasPorFamilia(headers)
          .then(response => {
            const {token, filiais} = response.data
            localStorage.token = token
            this.items = filiais
          })
          .catch(() => this.Helpers.logout())
      )
    },
    editarItem (item) {
      const categorias = item.categorias.filter(item => !item.sub_categoria)

      this.itemSelecionado = {
        edicao: true,
        grupo: item.id_grupo,
        filiais: [item.filial],
        familiais: this.Helpers.arrayColumn(item.familiais_gerais, 'idcategoria'),
        categorias: this.Helpers.arrayColumn(categorias, 'idcategoria')
      }
    },
    excluirMapeamentoFilial (filiais) {
      const headers = this.Helpers.iniciarRequisicao()

      this.$store.dispatch("loading/addRequisicao",
        FilialAPI.excluirMapeamentoFamiliaisFilial(headers, {filiais})
          .then(response => {
            localStorage.token = response.data.token
            this.itensSelecionados = []
            this.getListaFiliaisMapeadas()
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style scoped>

</style>
